import { useCallback, useEffect, useState } from 'react'
import { Marketplace, parseMarketplaceUrl, SourcingItemParams } from './handleUrl'
import AddProductCart from '../../../services/addProductCart.service'
import { Image, Modal, Spin } from 'antd'
import Product1688 from './Product1688'
import { LocalStore } from '../../../utils/LocalStore'
import { isEmpty } from 'lodash'

interface Props {
    openModal: boolean
    link: string
    handleModal: Function
    t: any
    loadData: Function
    handleClear: Function
}
const ModalProduct = (props: Props) => {
    const { openModal, handleModal, link, loadData, t, handleClear } = props
    const [product, setProduct] = useState<any>(null)
    const [loading, setLoading] = useState(false)

    // Normalize dữ liệu từ API customer/sourcing/items mới (dành cho Taobao / Sourcing)
    const normalizeProduct = (res: any, sourcingParams: SourcingItemParams) => {
        const itemData = res?.data || res

        const productId =
            itemData?.oid ||
            itemData?.miId ||
            sourcingParams?.itemId ||
            sourcingParams?.miId ||
            itemData?.offerId ||
            itemData?.id

        const isTaobao =
            itemData?.marketplace === 'taobao' ||
            itemData?.marketplace === 'tmall' ||
            (!itemData?.marketplace && itemData?.skus && !itemData?.productSkuInfos)

        const title = itemData?.title || itemData?.subject || itemData?.name || ''
        const images =
            itemData?.images && itemData?.images.length > 0
                ? itemData?.images
                : itemData?.mainImageUrl
                ? [itemData?.mainImageUrl]
                : []
        const mainImageUrl = itemData?.mainImageUrl || images[0] || ''

        // Định dạng Sourcing Items (có skus)
        if (itemData?.skus) {
            const formattedSkus = itemData?.skus?.map((sku: any) => {
                const skuImages =
                    sku?.images && sku?.images?.length > 0
                        ? sku?.images
                        : images?.length > 0
                        ? images
                        : []
                return {
                    ...sku,
                    skuId: String(sku?.skuId || sku?.oid || sku?.specId),
                    specId: String(sku?.specId || sku?.skuId || sku?.oid),
                    images: skuImages,
                    salePrice: sku?.salePrice,
                    variantProperties: sku?.variantProperties || [],
                }
            })

            return {
                ...itemData,
                title,
                subject: title,
                images,
                productImages: images,
                productImage: { images },
                mainImageUrl,
                merchant: {
                    id: itemData?.shopId || itemData?.merchant?.id || 'shop',
                    name: itemData?.shopName || itemData?.merchant?.name || 'shop',
                    marketplace: itemData?.marketplace || (isTaobao ? 'taobao' : '1688'),
                },
                shopId: itemData?.shopId || itemData?.merchant?.id,
                shopName: itemData?.shopName || itemData?.merchant?.name,
                skus: formattedSkus,
                stock: itemData?.inventory ?? itemData?.stock ?? 999,
                minOrderQuantity: itemData?.minOrderQuantity || 1,
                type: isTaobao ? Marketplace.Taobao : Marketplace.Alibaba,
                id: productId,
            }
        }

        return {
            ...itemData,
            title,
            subject: title,
            images,
            productImages: images,
            productImage: { images },
            mainImageUrl,
            merchant: {
                id: itemData?.shopId || itemData?.merchant?.id || 'shop',
                name: itemData?.shopName || itemData?.merchant?.name || 'shop',
                marketplace: itemData?.marketplace || (isTaobao ? 'taobao' : '1688'),
            },
            shopId: itemData?.shopId || itemData?.merchant?.id,
            shopName: itemData?.shopName || itemData?.merchant?.name,
            stock: itemData?.inventory ?? itemData?.stock ?? 999,
            minOrderQuantity: itemData?.minOrderQuantity || 1,
            type: isTaobao ? Marketplace.Taobao : Marketplace.Alibaba,
            id: productId,
        }
    }

    // 1. API mới dành cho Taobao: gọi /customer/sourcing/items
    const getDetailProductTaobaoNew = (sourcingParams: SourcingItemParams) => {
        setLoading(true)
        AddProductCart.getSourcingItem(sourcingParams, (err: any, res: any) => {
            if (!err && res) {
                const normalized = normalizeProduct(res, sourcingParams)
                setProduct(normalized)
                setLoading(false)
            } else {
                setProduct(null)
                setLoading(false)
            }
        })
    }

    // 2. Logic cũ dành cho 1688: gọi /customer/alibaba/fetch_global_product
    const getDetailProduct1688 = (itemId: string) => {
        setLoading(true)
        AddProductCart.getDetailProduct1688(itemId, (err: any, res: any) => {
            if (!err) {
                if (res) {
                    if (
                        res?.productSaleInfo?.priceRangeList?.length > 0 &&
                        res.batchNumber === null &&
                        res.productSkuInfos !== null
                    ) {
                        const consignPrice = res?.productSaleInfo?.priceRangeList?.[0]?.price
                        const productSkuInfos = !isEmpty(res?.productSkuInfos) ? res?.productSkuInfos?.map((item: any) => {
                            return { ...item, consignPrice: consignPrice }
                        }) : [{
                            amountOnSale: res?.productSaleInfo?.amountOnSale,
                            cargoNumber: "",
                            consignPrice: Number(res?.productSaleInfo?.priceRangeList?.[0]?.price || 0),
                            jxhyPrice: Number(res?.productSaleInfo?.priceRangeList?.[0]?.price || 0),
                            pfJxhyPrice: Number(res?.productSaleInfo?.priceRangeList?.[0]?.price || 0),
                            price: Number(res?.productSaleInfo?.priceRangeList?.[0]?.price || 0),
                            promotionPrice: Number(res?.productSaleInfo?.priceRangeList?.[0]?.price || 0),
                            skuAttributes: [{
                                attributeId: res?.productAttribute?.[0]?.attributeId,
                                attributeName: "Default",
                                attributeNameTrans: "",
                                skuImageUrl: null,
                                value: "",
                                valueTrans: "",
                            }],
                            skuId: res?.offerId,
                            specId: res?.offerId
                        }]
                        setProduct({
                            ...res,
                            productSkuInfos: productSkuInfos,
                            type: Marketplace.Alibaba,
                            id: itemId,
                        })
                    } else {
                        setProduct({
                            ...res,
                            type: Marketplace.Alibaba,
                            id: itemId,
                        })
                    }

                    setLoading(false)
                } else {
                    setProduct(null)
                    setLoading(false)
                }
            } else {
                setProduct(null)
                setLoading(false)
            }
        })
    }

    // 3. Logic xử lý mobile link (1688 Mobile giữ logic cũ, Taobao Mobile dùng API mới)
    const getMobileUrlResponse = useCallback((marketPlace: string, link: string) => {
        const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
        const loginSession = LocalStore.getInstance().read('loginSession') || {}
        const appApiUrl = process.env.REACT_APP_API_URL || window.location.hostname
        const marketplace = marketPlace === Marketplace.AlibabaMobile ? 'alibaba' : 'taobao'
        setLoading(true)
        fetch(`${appApiUrl}/customer/${marketplace}/get-link?shortLink=${link}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-tenant': currentProjectInfo.code,
                Authorization: 'Bearer ' + loginSession.id,
            },
        })
            .then(async res => {
                const data = await res.text()
                if (marketPlace === Marketplace.AlibabaMobile) {
                    // Logic cũ 1688 Mobile: bóc tách offerId -> gọi getDetailProduct1688
                    const idMatch = data.match(/offerId=([^&]+)/) || data.match(/offerId%3D(\d+)/)
                    if (idMatch) {
                        getDetailProduct1688(idMatch[1])
                    } else {
                        setLoading(false)
                    }
                } else {
                    // Taobao Mobile / Tmall Mobile: bóc tách id -> gọi API mới
                    const urlMatch: any = data.match(/var url = ['"]([^'"]+)['"]/)
                    const idProduct =
                        urlMatch?.[1]?.match(/itemIds=([^&]+)/)?.[1] ||
                        urlMatch?.[1]?.match(/id=([^&]+)/)?.[1] ||
                        null
                    if (idProduct) {
                        getDetailProductTaobaoNew({ itemId: idProduct, originalUrl: link })
                    } else {
                        getDetailProductTaobaoNew({ itemUrl: link, originalUrl: link })
                    }
                }
            })
            .catch(err => {
                if (marketPlace === Marketplace.AlibabaMobile) {
                    setLoading(false)
                    console.error(err)
                } else {
                    getDetailProductTaobaoNew({ itemUrl: link, originalUrl: link })
                }
            })
    }, [])

    useEffect(() => {
        if (!link) {
            setProduct(null)
            return
        }

        const marketplaceInfo = parseMarketplaceUrl(link)
        if (!marketplaceInfo) {
            setProduct(null)
            return
        }

        // 1. Ưu tiên: Nếu link có miId thì dùng API mới (Sourcing Taobao)
        if (marketplaceInfo.miId) {
            getDetailProductTaobaoNew({
                miId: marketplaceInfo.miId,
                originalUrl: marketplaceInfo.originalUrl,
            })
            return
        }

        // 2. Nếu là link Taobao / Tmall: Dùng API chi tiết sản phẩm mới
        if (
            marketplaceInfo.marketplace === Marketplace.Taobao ||
            marketplaceInfo.marketplace === Marketplace.Tmall
        ) {
            if (marketplaceInfo.productID) {
                getDetailProductTaobaoNew({
                    itemId: marketplaceInfo.productID,
                    originalUrl: marketplaceInfo.originalUrl,
                })
            } else {
                getDetailProductTaobaoNew({
                    itemUrl: marketplaceInfo.originalUrl,
                    originalUrl: marketplaceInfo.originalUrl,
                })
            }
            return
        }

        // 3. Nếu là link Taobao Mobile / Tmall Mobile: Dùng API mới sau khi resolve link
        if (
            marketplaceInfo.marketplace === Marketplace.TaobaoMobile ||
            marketplaceInfo.marketplace === Marketplace.TmallMobile
        ) {
            getMobileUrlResponse(marketplaceInfo.marketplace, marketplaceInfo.originalUrl!)
            return
        }

        // 4. Nếu là link 1688 (Desktop hoặc Mobile): Giữ nguyên logic cũ
        if (marketplaceInfo.marketplace === Marketplace.Alibaba) {
            if (marketplaceInfo.productID) {
                getDetailProduct1688(marketplaceInfo.productID)
            } else {
                setProduct(null)
            }
            return
        }

        if (marketplaceInfo.marketplace === Marketplace.AlibabaMobile) {
            getMobileUrlResponse(marketplaceInfo.marketplace, marketplaceInfo.originalUrl!)
            return
        }

        // 5. Link khác không nhận diện được: Giữ logic cũ (không hiển thị sản phẩm)
        setProduct(null)
    }, [link, getMobileUrlResponse])
    return (
        <Modal
            centered
            closable={!loading}
            maskClosable={!product ? true : false}
            className="modalAddToCart"
            bodyStyle={{ paddingTop: '32px', minHeight: !product && !loading ? 'auto' : '520px' }}
            title={null}
            open={openModal}
            footer={null}
            onCancel={() => {
                !loading && handleModal()
                // setIsModalAddCartOpen(false)
                // setDetailProductMp({})
                // handleClearParam()
            }}
            width={1000}
        >
            <Spin
                spinning={loading}
                className="h-[100vh] flex items-center justify-center"
            >
                {!product && !loading ? (
                    <>
                        <div className="text-center h-full">
                            <Image
                                style={{ width: '200px' }}
                                preview={false}
                                src={require('../../../resources/images/cartEmpty.png')}
                            />
                            <div className="mt-6 text-[#B1B1B1] text-center font-normal text-sm">
                                Sản phẩm không tồn tại hoặc đường dẫn bị sai! Vui lòng thử lại.
                            </div>
                        </div>
                    </>
                ) : null}
                {!loading && product && (
                    <Product1688
                        product={product}
                        loadData={loadData}
                        t={t}
                        link={link}
                        handleClear={handleClear}
                    />
                )}
            </Spin>
        </Modal>
    )
}

export default ModalProduct
